import { Character } from "@moe/priv/model/character";
import { createFileRoute } from "@tanstack/react-router";
import { useAppContext } from "@web/route-services/root/AppContext";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export const Route = createFileRoute("/dev")({
  component: Dev
});

function Dev() {
  const { access } = useAppContext();

  useEffect(() => {
    const fn = async () => {
      const char = await access.character.getPage({
        page: 1,
        pageSize: 20,
        ranking: "recommended",
        order: "desc"
      });
      console.log(char);
    };
    fn();
  }, [access.character]);

  return (
    <div className="bg-background h-scren flex w-screen flex-col overflow-y-auto">
      <button
        onClick={() => {
          toast("hi");
        }}
      >
        fasdf
      </button>
    </div>
  );
}
